import { render } from "./AppManageCaptioning.vue?vue&type=template&id=af5deaa2"
import script from "./AppManageCaptioning.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManageCaptioning.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AppManage/AppManageCaptioning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af5deaa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af5deaa2', __exports__)) {
    api.reload('af5deaa2', __exports__)
  }
  
  module.hot.accept("./AppManageCaptioning.vue?vue&type=template&id=af5deaa2", () => {
    api.rerender('af5deaa2', render)
  })

}


export default __exports__